import { cva } from '@/styled-system/css';

export const textButtonLabelRecipe = cva({
  base: {},
  variants: {
    tone: {
      'brand': {
        color: { base: 'TextButton.brand.label.default' },
      },
      'neutral': {
        color: { base: 'text.neutral' },
      },
      'neutral-fixed': {
        color: { base: 'text.action.neutral-fixed.default' },
      },
      'subtle': {
        color: { base: 'text.subtle' },
      },
      'critical': {
        color: { base: 'text.action.critical.hero.default' },
      },
    },
    onImpact: {
      true: {},
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    textStyle: {
      'body': {},
      'body-bold': {},
      'body-sm': {},
      'body-sm-bold': {},
    },
  },

  compoundVariants: [
    {
      onImpact: false,
      disabled: false,
      css: {
        textDecoration: {
          base: 'none',
          _groupHover: 'underline',
          _groupActive: 'underline',
        },
      },
    },
    {
      onImpact: true,
      disabled: false,
      css: {
        textDecoration: {
          base: 'none',
          _groupHover: 'underline',
          _groupActive: 'underline',
        },
      },
    },
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.label.hover',
          _groupActive: 'TextButton.brand.label.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.subtle',
          _groupActive: 'text.subtle',
        },
      },
    },
    {
      tone: 'critical',
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.neutral-fixed.hover',
          _groupActive: 'text.action.neutral-fixed.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'text.onImpact.action.neutral.default',
          _groupHover: 'text.onImpact.action.neutral.hover',
          _groupActive: 'text.onImpact.action.neutral.pressed',
        },
        textDecoration: {
          base: 'underline',
          _groupHover: 'none',
          _groupActive: 'none',
        },
      },
    },
    {
      tone: 'brand',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'text.onImpact.action.hero.default',
          _groupHover: 'text.onImpact.action.hero.hover',
          _groupActive: 'text.onImpact.action.hero.pressed',
        },
      },
    },
    {
      tone: 'critical',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'text.onImpact.action.critical.hero.default',
          _groupHover: 'text.onImpact.action.critical.hero.hover',
          _groupActive: 'text.onImpact.action.critical.hero.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'text.onImpact.neutral-fixed',
          _groupHover: 'text.onImpact.neutral-fixed',
          _groupActive: 'text.onImpact.neutral-fixed',
        },
      },
    },
  ],
});
